import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {ModalComponent} from 'app/core/modal.component';
import {AbstractSwitchesComponent} from 'app/core/switches.component';
import {SearchModelService} from 'app/core/search.interface';
import {SwitchCheckboxCollection, SwitchRadioCollection} from 'app/entities/switchCollection.entity';
import {AppColorList} from 'app/entities/enums';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-select-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class SelectModalComponent extends ModalComponent implements OnInit {

  @ViewChild('switchWrapper', {static: false}) switchWrapper: AbstractSwitchesComponent;

  collection: SwitchCheckboxCollection | SwitchRadioCollection = null;

  // input parameters:
  title: string = null;
  type: 'radio' | 'checkbox' = 'radio';
  search = false;
  custom = false;
  hideItemMark = false;
  showAcceptButton = false;
  autocompleteModel: SearchModelService = null;
  autocompleteHint: string = null;
  searchInput: string = null;
  cancelButtonText: string = null;
  acceptButtonText: string = null;
  acceptButtonColor: AppColorList = null;

  loading = false;

  customSwitchCollection: SwitchRadioCollection = null;

  debounce = 0;

  constructor(
    modalController: ModalController
  ) {
    super(modalController);
  }

  ngOnInit() {
    this.collection?.setAllVisible(true);

    setTimeout(() => {
      this.debounce = !this.autocompleteModel ? null : 1000;
    }, 100);
  }

  closeModal() {
    return super.closeModal();
  }

  saveAndClose(acceptClick = false) {
    if (acceptClick && this.autocompleteModel && this.searchInput && this.custom) {
      return super.closeModal({collection: new SwitchRadioCollection([{id: 1, title: this.searchInput, selected: true}])});
    } else {
      return super.closeModal({collection: this.collection});
    }
  }

  onChange() {
    if (this.type === 'radio' && !this.showAcceptButton) {
      this.saveAndClose();
    }
  }

  searchChange() {
    if (!!this.autocompleteModel) {
      this.makeModelSearch();
    } else {
      this.makeObjectSearch();
    }
  }

  makeObjectSearch() {
    let findOne = false;
    this.collection?.items?.forEach((item) => {
      if (item.subCollection?.items?.length && this.collection instanceof SwitchCheckboxCollection) {
        const descendants = this.collection.getDescendants(item);
        descendants.forEach(child => {
          if (this.searchInput) {
            child.visible = child.title.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
          } else {
            child.visible = true;
          }
        });
      } else {
        if (this.searchInput) {
          item.visible = item.title.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
        } else {
          item.visible = true;
        }
      }

      findOne = (this.searchInput.toLowerCase() === item.title.toLowerCase()) || findOne;
    });

    if (this.searchInput && !findOne && this.custom) {
      this.customSwitchCollection = new SwitchRadioCollection([{id: this.searchInput, title: this.searchInput}]);
    } else {
      this.customSwitchCollection = null;
    }
  }

  makeModelSearch() {
    this.loading = true;
    this.collection = null;

    this.autocompleteModel.searchItems(this.searchInput, (items) => {
      this.loading = false;
      this.collection = new SwitchRadioCollection(items);
    });
  }

  customSwitchItemSelected() {
    // this.customSwitchItem.visible = true;
    // this.customSwitchItem.selected = true;

    this.customSwitchCollection.items[0].selected = true;
    this.collection.addItems(this.customSwitchCollection.items, true);
    this.collection.itemSelect(this.customSwitchCollection.getSelectedId(), true);
    // console.log(this.items);

    // this.switchWrapper.setState(this.customSwitchItem.id, true, this.type === 'radio');
    this.customSwitchCollection = null;
  }

  searchNotFound() {
    return !this.custom && !(this.collection.items.some((item) => item.visible));
  }

  keyDown() {
    if (!!this.autocompleteModel) {
      this.loading = true;
    }
  }

  collectionAsCheckbox(): SwitchCheckboxCollection {
    return this.collection as SwitchCheckboxCollection;
  }

  collectionAsRadio(): SwitchRadioCollection {
    return this.collection as SwitchRadioCollection;
  }
}
